/**
 * Bảng tông màu và khoá dịch của phân hệ Quản lý module.
 *
 * Màu trạng thái **không** được quyết trong `src/mock/`: tầng đó bị xoá khi có
 * API thật, mà bảng tông phải sống lâu hơn nó.
 */
import type { BadgeVariant } from '../../components/ui';
import type { KhoaDich } from '../../i18n';
import type { MaLoiNopGoi, TrangThaiPhienBan } from './types';

/**
 * Tông của trạng thái phiên bản — thang **trạng thái**, có mức độ nặng nhẹ
 * thật: `IN_REVIEW` đang chờ người xử lý (`warning`), `REJECTED` cần biết ngay
 * (`danger`), `PUBLISHED` đang phục vụ (`success`), `DRAFT`/`DEPRECATED` là
 * những bản không còn (hoặc chưa) tác động gì (`neutral`).
 */
export const TRANG_THAI_PHIEN_BAN: Record<TrangThaiPhienBan, { khoa: KhoaDich; variant: BadgeVariant }> = {
  DRAFT: { khoa: 'quanLyModule.trangThai.DRAFT', variant: 'neutral' },
  IN_REVIEW: { khoa: 'quanLyModule.trangThai.IN_REVIEW', variant: 'warning' },
  PUBLISHED: { khoa: 'quanLyModule.trangThai.PUBLISHED', variant: 'success' },
  REJECTED: { khoa: 'quanLyModule.trangThai.REJECTED', variant: 'danger' },
  DEPRECATED: { khoa: 'quanLyModule.trangThai.DEPRECATED', variant: 'neutral' },
};

/** Nhãn mã lỗi khi nộp gói không đạt (ADR-0045 mục 2), hiện ngay dưới khu vực upload. */
export const MA_LOI_NOP_GOI: Record<MaLoiNopGoi, KhoaDich> = {
  MODULE_PACKAGE_INVALID: 'quanLyModule.maLoiKiem.MODULE_PACKAGE_INVALID',
  MODULE_MANIFEST_INVALID: 'quanLyModule.maLoiKiem.MODULE_MANIFEST_INVALID',
  MODULE_VERSION_CONFLICT: 'quanLyModule.maLoiKiem.MODULE_VERSION_CONFLICT',
  MODULE_SCAN_FAILED: 'quanLyModule.maLoiKiem.MODULE_SCAN_FAILED',
  MODULE_MIGRATION_INVALID: 'quanLyModule.maLoiKiem.MODULE_MIGRATION_INVALID',
};
